import { finishExerciseRun, type ExerciseRunScore } from "./learning-api";

export type RunCompletionStatus = { phase: "idle" | "saving" | "failed"; error: string };

// Keep the final state until saving succeeds, including across an explicit retry.
export function createRunCompletion(onStatus: (status: RunCompletionStatus) => void) {
  let pending: { runId: string; commit: (result: ExerciseRunScore) => void } | null = null;
  let saving: Promise<void> | null = null;
  let completedRunId: string | null = null;

  function save(): Promise<void> {
    if (saving) return saving;
    if (!pending) return Promise.resolve();
    const completion = pending;
    onStatus({ phase: "saving", error: "" });
    saving = (async () => {
      try {
        const result = await finishExerciseRun(completion.runId);
        completion.commit({ score: result.score, maxScore: result.maxScore });
        completedRunId = completion.runId;
        pending = null;
        onStatus({ phase: "idle", error: "" });
      } catch (error) {
        onStatus({ phase: "failed", error: error instanceof Error ? error.message : "Der Abschluss konnte nicht gespeichert werden." });
      } finally {
        saving = null;
      }
    })();
    return saving;
  }

  return {
    complete(runId: string, commit: (result: ExerciseRunScore) => void) {
      if (pending || completedRunId === runId) return saving ?? Promise.resolve();
      pending = { runId, commit };
      return save();
    },
    retry: save,
  };
}
